import { Modal, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Divider from "../Common/Divider/Divider";

function MetaDataModal({ metaModalView, metaModalClose, metaData }) {

  const DocumentScore=[Math.ceil(Math.random()*5)];
  const newfield={
    "Document Score" : DocumentScore
  }
  metaData.push(newfield)


  const MetaDataItem = ({name, value }) => (
    <>
      <div className="col-5 pt-2 text-muted">{name}</div>
      <div className="col-7 pt-2">{value}</div>
    </>
  );

  return (
    <>
      <Modal show={metaModalView} onHide={metaModalClose}>
        <Modal.Header closeButton className="fs-4">
          Document Meta Data
        </Modal.Header>
        <ModalBody>
          <div className="row">
            {metaData?.map((metaDataItem, index) => (
              <>
              <MetaDataItem key={index} name={Object.keys(metaDataItem)[0]} value={Object.values(metaDataItem)[0]} />
              <Divider/>
              </>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="btn btn-primary" onClick={metaModalClose}>
            Ok
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default MetaDataModal;
